var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16 1a1 1 0 0 0-1-1h-5a1 1 0 0 0 0 2h2.57L9.29 5.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0L14 3.42V6a1 1 0 0 0 2 0V1zM6.71 9.29a1 1 0 0 0-1.42 0L2 12.57V10a1 1 0 0 0-2 0v5a1 1 0 0 0 1 1h5a1 1 0 0 0 0-2H3.42l3.29-3.29a1 1 0 0 0 0-1.42z", fill: "#545454" })
  );
});